import { render, staticRenderFns } from "./addCharges.vue?vue&type=template&id=2fdcdd86"
import script from "./addCharges.vue?vue&type=script&lang=js"
export * from "./addCharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports